import { defineStore } from 'pinia';
import { ref, watch } from 'vue';
import useMatestoreStore from '@/store/matestoreStore';
import { getVueRouter } from '@/router';
import qs from 'qs';

interface Route {
  path: string;
  name: string;
  fullPath: string;
  query: Record<string, any>;
  params: Record<string, any>;
  hash: string;
}

export const useGlobalRouteStore = defineStore('globalRoute', () => {
  const globalOptions = ref<any>({});
  const currentRoute = ref<Partial<Route>>();
  const routeHistory = ref<Partial<Route>[]>([]);

  const routerPush = (route: Partial<Route> | string, isReplace?: boolean) => {
    const router = getVueRouter();
    const toMicroRoute = parsePath(route);
    // if (typeof route === 'object') {
    //   routeHistory.value.push(route);
    // }
    const currentSearch = window.location.search.replace(/^\?/, '');
    if (
      window.location.pathname === toMicroRoute?.path &&
      currentSearch == qs.stringify(toMicroRoute?.query)
    ) {
      // @ts-ignore
      window.location.hash = toMicroRoute.hash;
    } else {
      if (isReplace) {
        router.replace(route);
      } else {
        router.push(route);
      }
    }
  };

  const routerReplace = (route: Partial<Route> | string) =>
    routerPush(route, true);

  const getMicroNameFromPathname = (pathname: string = '') => {
    pathname.replace(globalOptions.value.base, '');
    return pathname.replace(/(^\/)|(\/$)/g, '');
  };

  const getRouteFromUrl = (url?: URL): Partial<Route> => {
    if (!url) {
      url = window.location as unknown as URL;
    }
    const { search = '', hash = '', pathname } = url;
    return {
      fullPath: `${pathname}${search}${hash}`,
      hash,
      path: pathname,
      query: qs.parse(search.replace(/^\?/, '')),
      name: getMicroNameFromPathname(pathname),
    };
  };

  const getCurrentAppFromRoute = (route?: Partial<Route>) => {
    if (!route) {
      route = getRouteFromUrl();
    }
    const microStore = useMatestoreStore();
    const microName = getMicroNameFromPathname(route.path);
    const microApp = microStore.microMap[microName];
    return microApp;
  };

  const parsePath = (path: Partial<Route> | string) => {
    if (typeof path === 'object' && path?.fullPath) {
      path = path?.fullPath;
    } else if (typeof path === 'object') {
      let { path: p, name, hash, query } = path;
      if (hash && !/^#/.test(hash)) {
        hash = `#${hash}`;
      }
      let queryString = '';
      if (query) {
        if (p?.includes('?')) {
          const [pathname, search] = p.split('?');
          query = { ...qs.parse(search), ...query };
          p = pathname;
        }
        queryString = `?${qs.stringify(path.query)}`;
      }
      path = `${p ? p : `/${name}`}${queryString}${hash}`;
    }

    const url = new URL(
      `${window.location.protocol}//${window.location.host}${path}`
    );
    return getRouteFromUrl(url);
  };

  const initialize = (options: { base?: string } = { base: '/' }) => {
    globalOptions.value = options;
    currentRoute.value = getRouteFromUrl();
    window.addEventListener('hashchange', () => {
      currentRoute.value = getRouteFromUrl();
      console.log('current route after hashchange', currentRoute.value);
    });
    window.addEventListener('popstate', (event) => {
      currentRoute.value = getRouteFromUrl();
      console.log('current route after popstate', currentRoute.value);
      console.log('History.state before pushState: ', history.state);
      setTimeout(() => {
        /*清除history，原理不明，这样可达成跳转的诉求*/
        window.history.replaceState(null, '1', null);
      }, 100);
    });
    setTimeout(() => {
      /*清除history，原理不明，这样可达成跳转的诉求*/
      window.history.replaceState(null, '1', null);
    }, 100);
  };

  watch(
    () => currentRoute.value?.fullPath,
    () => {
      if (!currentRoute.value) {
        return;
      }
      const microApp = getCurrentAppFromRoute(currentRoute.value);
      if (microApp) {
        microApp.latestUsedPath = currentRoute.value?.fullPath;
        console.log('current microApp', microApp.name);
        console.log('latestUsedPath', microApp.latestUsedPath);
      }
    }
  );

  return {
    currentRoute,
    push: routerPush,
    replace: routerReplace,
    initialize,
    getCurrentAppFromRoute,
    getRouteFromUrl,
    parsePath,
  };
});

export type IGlobalRouterStore = ReturnType<typeof useGlobalRouteStore>;
